import React, { useState } from 'react';
import Tab from './Tab';

const Tabs = ({ children }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    children.length > 0 && (
      <div className="tabs">
        <ul className="tabs__titles">
          {children.map((child, index) => {
            const { label } = child.props;
            return (
              <Tab
                key={index}
                isActive={index === activeTab}
                label={label}
                onClick={() => setActiveTab(index)}
              />
            );
          })}
        </ul>
        <div className="tabs__content">{children[activeTab].props.children}</div>
      </div>
    )
  );
};

export default Tabs;
